import { jsx as _jsx } from "react/jsx-runtime";
import { CompactItem } from "./CompactItem";
import { RegularItem } from "./RegularItem";
export const CartItem = ({ isLimitEnabled = false, blockQuantityAdd = false, variant = "regular", ...props }) => {
    if (variant === "regular") {
        return _jsx(RegularItem, { isLimitEnabled: isLimitEnabled, blockQuantityAdd: blockQuantityAdd, ...props });
    }
    if (variant === "compact") {
        return _jsx(CompactItem, { blockQuantityAdd: blockQuantityAdd, ...props });
    }
    return null;
};
//# sourceMappingURL=CartItem.js.map